// extracted by mini-css-extract-plugin
export default {"icon":"notifications_icon__9WvXM","title":"notifications_title__FVdgh","date":"notifications_date__u3u-4"};